import React from 'react'

import './ReservaYa.scss'

const webImages = {
  hero: '/assets/img/reserva-ya/hero.jpg',
  client: '/assets/img/reserva-ya/client.jpg',
  beauty: '/assets/img/reserva-ya/beauty.jpg',
  sports: '/assets/img/reserva-ya/sports.jpg',
  business: '/assets/img/reserva-ya/business.jpg'
}

export default function ReservaYa() {
  return (
    <div className="reserva-page">
      {/* HERO */}
      <section className="reserva-hero">
        <div className="reserva-container">
          <div className="hero-content">
            <span className="hero-badge">
              <i className="bi bi-calendar-check-fill"></i>
              Reserva Ya
            </span>

            <h1>
              Reserva lo que necesitas.
              <span> Cuando lo necesitas.</span>
            </h1>

            <p>
              Encuentra espacios, servicios y profesionales cerca de ti. Reserva
              en pocos pasos y administra todo desde una sola aplicación.
            </p>

            <div className="hero-actions">
              <a href="#clientes" className="reserva-btn primary">
                Quiero reservar
                <i className="bi bi-arrow-right"></i>
              </a>

              <a href="#negocios" className="reserva-btn secondary">
                Soy un negocio
                <i className="bi bi-building"></i>
              </a>
            </div>

            <div className="hero-trust">
              <div>
                <i className="bi bi-check-circle-fill"></i>
                Reservas 24/7
              </div>

              <div>
                <i className="bi bi-check-circle-fill"></i>
                Fácil y rápido
              </div>

              <div>
                <i className="bi bi-check-circle-fill"></i>
                Desde cualquier lugar
              </div>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-image-card">
              <img src={webImages.hero} alt="Reserva Ya" />
            </div>

            <div className="floating-card reservation-card">
              <div className="floating-icon">
                <i className="bi bi-calendar-check"></i>
              </div>

              <div>
                <strong>Reserva confirmada</strong>
                <span>Hoy · 11:00 - 12:00</span>
              </div>

              <i className="bi bi-check-circle-fill success"></i>
            </div>

            <div className="floating-card app-card">
              <i className="bi bi-phone"></i>
              <span>Todo desde tu celular</span>
            </div>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="reserva-intro">
        <div className="reserva-container">
          <div className="section-heading centered">
            <span>UNA SOLA PLATAFORMA</span>

            <h2>
              Todo lo que necesitas para
              <strong> reservar y administrar.</strong>
            </h2>

            <p>
              Reserva Ya conecta a personas que buscan servicios con negocios
              que quieren administrar sus reservas de una manera simple, moderna
              y organizada.
            </p>
          </div>

          <div className="audience-grid">
            <article className="audience-card client-card" id="clientes">
              <div className="audience-image">
                <img src={webImages.client} alt="Clientes Reserva Ya" />
              </div>

              <div className="audience-content">
                <span className="small-label">PARA CLIENTES</span>

                <h3>Encuentra. Reserva. Disfruta.</h3>

                <p>
                  Descubre espacios y servicios, consulta disponibilidad y
                  realiza tus reservas sin llamadas ni mensajes.
                </p>

                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Busca espacios y servicios
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Consulta horarios disponibles
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Reserva en pocos pasos
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Administra tus reservas
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Consulta tu historial
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Comparte y gana beneficios
                  </li>
                </ul>

                <a href="#descargar" className="text-link">
                  Descargar Reserva Ya
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </article>

            <article className="audience-card business-card" id="negocios">
              <div className="audience-image">
                <img src={webImages.business} alt="Negocios Reserva Ya" />
              </div>

              <div className="audience-content">
                <span className="small-label">PARA NEGOCIOS</span>

                <h3>Convierte tu agenda en una herramienta de crecimiento.</h3>

                <p>
                  Administra servicios, horarios, clientes y reservas desde un
                  solo lugar y ofrece a tus clientes una experiencia moderna.
                </p>

                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Administra tus servicios
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Configura horarios y turnos
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Gestiona reservas
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Administra clientes
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Crea promociones
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Consulta reportes y estadísticas
                  </li>
                </ul>

                <a href={global.TEST_REQUEST} className="text-link">
                  Solicitar una demo
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* CLIENT EXPERIENCE */}
      <section className="feature-section light-section">
        <div className="reserva-container feature-layout">
          <div className="feature-content">
            <span className="section-label">EXPERIENCIA DEL CLIENTE</span>

            <h2>
              Reservar nunca debería
              <strong> ser complicado.</strong>
            </h2>

            <p>
              Desde la búsqueda hasta la confirmación, Reserva Ya está diseñada
              para que encontrar y reservar un servicio sea rápido, claro y
              sencillo.
            </p>

            <div className="feature-list">
              <div>
                <span>01</span>
                <div>
                  <h4>Descubre</h4>
                  <p>Explora negocios, espacios y servicios disponibles.</p>
                </div>
              </div>

              <div>
                <span>02</span>
                <div>
                  <h4>Elige</h4>
                  <p>
                    Consulta información, precios, horarios y disponibilidad.
                  </p>
                </div>
              </div>

              <div>
                <span>03</span>
                <div>
                  <h4>Reserva</h4>
                  <p>
                    Selecciona el horario que prefieras y confirma tu reserva.
                  </p>
                </div>
              </div>

              <div>
                <span>04</span>
                <div>
                  <h4>Disfruta</h4>
                  <p>Consulta tus reservas y mantén todo organizado.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="feature-visual">
            <div className="phone-placeholder">
              <img src={webImages.beauty} alt="Servicios Reserva Ya" />
            </div>

            <div className="feature-stat">
              <i className="bi bi-lightning-charge-fill"></i>

              <div>
                <strong>Simple y rápido</strong>
                <span>Reserva desde cualquier lugar</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BUSINESS */}
      <section className="business-section">
        <div className="reserva-container">
          <div className="section-heading centered">
            <span>PARA TU NEGOCIO</span>

            <h2>
              Tu negocio.
              <strong> Tu agenda. Tu control.</strong>
            </h2>

            <p>
              Reserva Ya te ayuda a organizar la operación diaria de tu negocio
              y a ofrecer a tus clientes una experiencia de reserva digital.
            </p>
          </div>

          <div className="business-features">
            <div className="business-feature">
              <div className="feature-icon">
                <i className="bi bi-calendar3"></i>
              </div>

              <h3>Agenda</h3>

              <p>
                Visualiza las reservas del día y administra tu disponibilidad.
              </p>
            </div>

            <div className="business-feature">
              <div className="feature-icon">
                <i className="bi bi-tools"></i>
              </div>

              <h3>Gestión</h3>

              <p>
                Administra servicios, horarios, turnos, promociones y clientes.
              </p>
            </div>

            <div className="business-feature">
              <div className="feature-icon">
                <i className="bi bi-gear"></i>
              </div>

              <h3>Configuración</h3>

              <p>Configura tu negocio y adapta la plataforma a tu operación.</p>
            </div>

            <div className="business-feature">
              <div className="feature-icon">
                <i className="bi bi-bar-chart"></i>
              </div>

              <h3>Reportes</h3>

              <p>
                Obtén información sobre tus reservas y el comportamiento de tu
                negocio.
              </p>
            </div>
          </div>

          <div className="business-banner">
            <div>
              <span>HAZ CRECER TU NEGOCIO</span>

              <h3>
                Menos tiempo organizando.
                <br />
                Más tiempo atendiendo.
              </h3>

              <p>
                Dale a tus clientes una forma moderna de reservar y mantén el
                control de tu negocio desde una sola plataforma.
              </p>

              <a
                href={global.TEST_REQUEST}
                target="_blank"
                rel="noopener noreferrer"
                className="reserva-btn white"
              >
                Solicitar demo
                <i className="bi bi-arrow-up-right"></i>
              </a>
            </div>

            <img src={webImages.sports} alt="Reserva Ya para negocios" />
          </div>
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="categories-section">
        <div className="reserva-container">
          <div className="section-heading centered">
            <span>MUCHAS POSIBILIDADES</span>

            <h2>
              Un lugar para
              <strong> cada tipo de reserva.</strong>
            </h2>

            <p>
              Reserva Ya puede adaptarse a diferentes negocios, espacios y
              servicios que trabajan con disponibilidad y horarios.
            </p>
          </div>

          <div className="categories-grid">
            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-trophy-fill"></i>
              </div>

              <h3>Deportes</h3>
              <p>Canchas, gimnasios y espacios deportivos.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-building-fill"></i>
              </div>

              <h3>Coworking</h3>
              <p>Oficinas, salas y espacios de trabajo.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-stars"></i>
              </div>

              <h3>Belleza</h3>
              <p>Salones, estética y servicios personales.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-calendar-event-fill"></i>
              </div>

              <h3>Eventos</h3>
              <p>Espacios y servicios para tus eventos.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-heart-pulse-fill"></i>
              </div>

              <h3>Consultorios</h3>
              <p>Servicios profesionales y atención.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-grid-3x3-gap-fill"></i>
              </div>

              <h3>Y mucho más</h3>
              <p>Todo negocio que trabaja con reservas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* APP SHOWCASE */}
      <section className="showcase-section">
        <div className="reserva-container">
          <div className="section-heading centered">
            <span>CONOCE LA APP</span>

            <h2>
              Diseñada para que
              <strong> todo sea más fácil.</strong>
            </h2>

            <p>
              Una experiencia sencilla para clientes y herramientas completas
              para los negocios.
            </p>
          </div>

          {/* CLIENTES */}
          <div className="screens-grid">
            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/home.png"
                  alt="Reserva Ya inicio"
                />
              </div>

              <h4>Descubre servicios</h4>
              <p>Encuentra lo que necesitas.</p>
            </div>

            <div className="screen-card featured-screen">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/reservas.png"
                  alt="Reserva Ya mis reservas"
                />
              </div>

              <h4>Administra tus reservas</h4>
              <p>Todo organizado en un solo lugar.</p>
            </div>

            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/referidos.png"
                  alt="Reserva Ya referidos"
                />
              </div>

              <h4>Comparte y gana</h4>
              <p>Invita y obtén beneficios.</p>
            </div>
          </div>

          {/* NEGOCIOS */}
          <div className="screens-grid business-screens">
            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/agenda.png"
                  alt="Reserva Ya agenda"
                />
              </div>

              <h4>Agenda</h4>
              <p>Controla las reservas de tu negocio.</p>
            </div>

            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/gestion.png"
                  alt="Reserva Ya gestión"
                />
              </div>

              <h4>Gestión</h4>
              <p>Administra tu operación.</p>
            </div>

            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/configuracion.png"
                  alt="Reserva Ya configuración"
                />
              </div>

              <h4>Configuración</h4>
              <p>Adapta Reserva Ya a tu negocio.</p>
            </div>
          </div>

          {/* REPORTES */}
          <div className="screens-grid business-screens">
            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/reportes.png"
                  alt="Reserva Ya reportes"
                />
              </div>

              <h4>Reportes</h4>
              <p>Conoce el rendimiento de tu negocio.</p>
            </div>

            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/estado-reservas.png"
                  alt="Reserva Ya estado de reservas"
                />
              </div>

              <h4>Estado de reservas</h4>
              <p>Visualiza reservas confirmadas, pendientes y canceladas.</p>
            </div>

            <div className="screen-card">
              <div className="screen-image">
                <img
                  src="/assets/img/reserva-ya/screens/ingresos.png"
                  alt="Reserva Ya ingresos"
                />
              </div>

              <h4>Ingresos</h4>
              <p>Analiza ingresos y tendencias de tu negocio.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="download-section" id="descargar">
        <div className="reserva-container">
          <div className="download-content">
            <span>RESERVA YA</span>

            <h2>
              Tu próxima reserva
              <strong> empieza aquí.</strong>
            </h2>

            <p>
              Descarga Reserva Ya y descubre una nueva forma de encontrar y
              reservar servicios.
            </p>

            <div className="store-buttons">
              <a href="#" className="store-button">
                <i className="bi bi-google-play"></i>

                <div>
                  <small>Disponible en</small>
                  <strong>Google Play</strong>
                </div>
              </a>

              <a href="#" className="store-button">
                <i className="bi bi-apple"></i>

                <div>
                  <small>Descarga en</small>
                  <strong>App Store</strong>
                </div>
              </a>
            </div>
          </div>

          <div className="download-visual">
            <div className="download-circle"></div>

            <div className="download-phone">
              <img
                src="/assets/img/reserva-ya/screens/home.png"
                alt="Aplicación Reserva Ya"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FINAL BUSINESS CTA */}
      <section className="final-cta">
        <div className="reserva-container">
          <div>
            <span>¿TIENES UN NEGOCIO?</span>

            <h2>
              Lleva tus reservas
              <br />
              al siguiente nivel.
            </h2>

            <p>
              Empieza a ofrecer reservas online y administra tu negocio de forma
              más eficiente.
            </p>
          </div>

          <a
            href={global.TEST_REQUEST}
            target="_blank"
            rel="noopener noreferrer"
            className="reserva-btn white"
          >
            Solicitar una demo
            <i className="bi bi-arrow-up-right"></i>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="reserva-footer">
        <div className="reserva-container footer-content">
          <div className="footer-brand">
            <div className="brand-logo">
              <span>R</span>
              <strong>Reserva Ya</strong>
            </div>

            <p>
              La forma simple de reservar servicios y administrar tu negocio.
            </p>
          </div>

          <div className="footer-links">
            <div>
              <h4>Reserva Ya</h4>

              <a href="#clientes">Para clientes</a>
              <a href="#negocios">Para negocios</a>
              <a href="#descargar">Descargar app</a>
            </div>

            <div>
              <h4>Información</h4>

              <a href={global.TERM_CONDITION}>Términos y condiciones</a>
              <a href={global.DIGITAL_DATA}>Privacidad</a>
              <a href={global.TEST_REQUEST}>Soporte</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="reserva-container">
            <span>
              © {new Date().getFullYear()} SIGMATEC. Todos los derechos
              reservados.
            </span>

            <span>Reserva Ya</span>
          </div>
        </div>
      </footer>
    </div>
  )
}
